import * as yup from 'yup';
const phoneRegex = /^[0-9+\-().\s]*$/;
const phoneValidationSchema = yup
      .string()
      .nullable()
      .notRequired()
      .test("is-valid-phone", "Invalid phone number", (value) => {
        if (!value) return true;
        return phoneRegex.test(value);
      })
export const ProjectValidationSchema = yup.object({
  resourceName: yup.string().trim().required('Resource Name is required'),
  projectName: yup.string().trim().required('Project Name is required'),
  managerName: yup.string().trim().required('Manager Name is required'),
  clientName: yup.string().trim().required('Client Name is required'),
  clientManagerPhone:phoneValidationSchema,
  msaSignatoryPhone:phoneValidationSchema,
  recruiterPhone:phoneValidationSchema,
  accountingContactPhone:phoneValidationSchema,
  escalationContactPhone:phoneValidationSchema,
  timesheetTo: yup.string().trim().notRequired().email('Please enter a valid email'),
  invoiceTo: yup.string().trim().notRequired().email('Please enter a valid email'),
  msaSignatoryEmail: yup.string().trim().notRequired().email('Please enter a valid email'),
  clientManagerEmail: yup.string().trim().notRequired().email('Please enter a valid email'),
  recruiterEmail: yup.string().trim().notRequired().email('Please enter a valid email'),
  accountingContactEmail: yup.string().trim().notRequired().email('Please enter a valid email'),
  escalationContactEmail: yup.string().trim().notRequired().email('Please enter a valid email'),

  poStartDate: yup.string().trim().notRequired(),
  poEndDate: yup.string().trim().notRequired(),
}).test('poDatesValidation', 'Invalid PO Date combination', function (values) {
  const { poStartDate, poEndDate } = values;

  if (poEndDate && !poStartDate) {
    return this.createError({ path: 'poStartDate', message: 'Start Date is required when End Date is provided' });
  }

  if (poStartDate && poEndDate && new Date(poStartDate) > new Date(poEndDate)) {
    return this.createError({ path: 'poStartDate', message: 'Start Date cannot be later than End Date' });
  }

  return true;
});
